import { MessageCircle, Mail, ArrowUpRight } from "lucide-react";
import { BRAND, NAV_LINKS } from "../lib/data";
import logoFull from "../assets/logo-full.png";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative bg-brand-surface border-t border-white/5 pt-24 overflow-hidden">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <div className="grid md:grid-cols-3 gap-12 pb-20">
        <div>
          <img src={logoFull} loading="lazy" alt="ECU SOLUTIONS Lorenzen – Wartung, Diagnose, Optimierung" className="h-20 w-auto max-w-full object-contain mb-5" />
          <p className="text-brand-light/0 text-white/50 text-sm leading-relaxed max-w-xs">
            Chiptuning & Steuergeräte-Lösungen direkt am Fahrzeug – für Werkstätten, Tuner und ambitionierte Fahrer.
          </p>
        </div>

        <div>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-brand mb-5">Navigation</p>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <a href={`/${l.href}`} className="text-white/60 hover:text-white text-sm transition-colors">{l.label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-brand mb-5">Kontakt</p>
          <a href={`mailto:${BRAND.email}`} className="flex items-center gap-2 text-white/70 hover:text-white text-sm mb-3 transition-colors">
            <Mail size={15} />{BRAND.email}
          </a>
          <a href={`https://wa.me/${BRAND.whatsapp}`} target="_blank" rel="noreferrer"
             className="flex items-center gap-2 text-white/70 hover:text-[#25D366] text-sm mb-6 transition-colors">
            <MessageCircle size={15} />{BRAND.whatsappDisplay}
          </a>
        </div>
      </div>

      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 py-8 border-t border-white/5">
        <div className="flex flex-wrap gap-6">
          <a href="/impressum" data-testid="footer-impressum" className="font-mono text-xs uppercase tracking-wider text-white/50 hover:text-white transition-colors">Impressum</a>
          <a href="/datenschutz" data-testid="footer-datenschutz" className="font-mono text-xs uppercase tracking-wider text-white/50 hover:text-white transition-colors">Datenschutz</a>
          <a href="/agb" data-testid="footer-agb" className="font-mono text-xs uppercase tracking-wider text-white/50 hover:text-white transition-colors">AGB</a>
        </div>
        <p className="font-mono text-xs text-white/40">{`© ${new Date().getFullYear()} ECU SOLUTIONS · ${BRAND.domain}`}</p>
      </div>
    </div>

    <div className="w-full overflow-hidden select-none pointer-events-none">
      <p aria-hidden="true" className="font-display font-black text-[16vw] leading-[0.8] text-center whitespace-nowrap text-white/[0.04] -mb-[3vw]">
        ECU SOLUTIONS
      </p>
    </div>

    <div className="border-t border-white/5 py-6">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 font-mono text-xs uppercase tracking-[0.2em] text-white/40">
        <a href="https://filesuite.de" target="_blank" rel="noreferrer"
           data-testid="made-by-filesuite"
           className="flex items-center gap-1.5 hover:text-brand transition-colors">
          Website by Filesuite <ArrowUpRight size={13} />
        </a>
      </div>
    </div>
  </footer>
);
